var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 41,
    viewBox: "0 0 125 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 124,
    height: 40,
    rx: 4.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 124,
    height: 40,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.089 22.2947C60.9112 22.2947 59.1362 24.1285 59.1362 26.6541C59.1362 29.1643 60.9112 31.0134 63.089 31.0134C65.2677 31.0134 67.0427 29.1643 67.0427 26.6541C67.0418 24.1285 65.2668 22.2947 63.089 22.2947ZM63.089 29.2975C61.8955 29.2975 60.8668 28.208 60.8668 26.6551C60.8668 25.0858 61.8964 24.0126 63.089 24.0126C64.2825 24.0126 65.3112 25.0858 65.3112 26.6551C65.3112 28.2069 64.2825 29.2975 63.089 29.2975ZM54.4649 22.2947C52.2871 22.2947 50.5121 24.1285 50.5121 26.6541C50.5121 29.1643 52.2871 31.0134 54.4649 31.0134C56.6436 31.0134 58.4186 29.1643 58.4186 26.6541C58.4186 24.1285 56.6436 22.2947 54.4649 22.2947ZM54.4649 29.2975C53.2714 29.2975 52.2427 28.208 52.2427 26.6551C52.2427 25.0858 53.2723 24.0126 54.4649 24.0126C55.6584 24.0126 56.6871 25.0858 56.6871 26.6551C56.6881 28.2069 55.6584 29.2975 54.4649 29.2975ZM44.2075 23.6334V25.4825H48.2057C48.0862 26.5229 47.7732 27.2824 47.2955 27.8103C46.714 28.454 45.8038 29.1643 44.2075 29.1643C41.7464 29.1643 39.8223 26.9677 39.8223 24.2433C39.8223 21.5188 41.7464 19.3222 44.2075 19.3222C45.5353 19.3222 46.5047 19.9003 47.2205 20.6435L48.3992 19.3386C47.3992 18.2819 46.0723 17.4731 44.2075 17.4731C40.8362 17.4731 38.002 20.5112 38.002 24.2433C38.002 27.9753 40.8362 31.0134 44.2075 31.0134C46.027 31.0134 47.4001 30.3523 48.4733 29.1141C49.577 27.8923 49.9205 26.1744 49.9205 24.7875C49.9205 24.3591 49.8908 23.9624 49.8307 23.6324H44.2075V23.6334ZM86.1594 25.0694C85.8316 24.0957 84.8316 22.2947 82.7881 22.2947C80.7594 22.2947 79.0733 24.0618 79.0733 26.6541C79.0733 29.0977 80.7445 31.0134 82.9816 31.0134C84.7862 31.0134 85.8307 29.7916 86.264 29.0813L84.9214 28.0901C84.4742 28.8168 83.8621 29.2955 82.9816 29.2955C82.102 29.2955 81.4751 28.8496 81.0723 27.9743L86.3381 25.5635L86.1594 25.0694ZM80.789 26.5229C80.7445 24.8378 81.9677 23.9798 82.8483 23.9798C83.5344 23.9798 84.1158 24.3601 84.3103 24.9044L80.789 26.5229ZM76.5084 30.75H78.2381V17.9364H76.5084V30.75ZM73.6733 23.2695H73.614C73.226 22.757 72.4797 22.2947 71.5408 22.2947C69.5714 22.2947 67.7668 24.2105 67.7668 26.6715C67.7668 29.1151 69.5714 31.0144 71.5408 31.0144C72.4807 31.0144 73.226 30.5521 73.614 30.0243H73.6733V30.6516C73.6733 32.3192 72.8677 33.211 71.5705 33.211C70.5112 33.211 69.8547 32.3695 69.5862 31.6591L68.0797 32.3531C68.5121 33.5082 69.6603 34.9289 71.5705 34.9289C73.5992 34.9289 75.3149 33.6077 75.3149 30.3871V22.5602H73.6742V23.2695H73.6733ZM71.6899 29.2975C70.4964 29.2975 69.4973 28.1905 69.4973 26.6715C69.4973 25.135 70.4964 24.0126 71.6899 24.0126C72.8677 24.0126 73.7927 25.135 73.7927 26.6715C73.7927 28.1905 72.8677 29.2975 71.6899 29.2975ZM94.2649 17.9364H90.1251V30.75H91.852V25.8956H94.264C96.1788 25.8956 98.0621 24.3611 98.0621 21.9165C98.0621 19.4719 96.1797 17.9364 94.2649 17.9364ZM94.3094 24.1121H91.852V19.7199H94.3094C95.601 19.7199 96.3344 20.9038 96.3344 21.9165C96.3344 22.9087 95.601 24.1121 94.3094 24.1121ZM104.987 22.2722C103.736 22.2722 102.441 22.8821 101.905 24.234L103.438 24.9423C103.766 24.234 104.377 24.0024 105.017 24.0024C105.91 24.0024 106.819 24.5959 106.833 25.6506V25.7828C106.52 25.585 105.85 25.2888 105.032 25.2888C103.379 25.2888 101.695 26.2943 101.695 28.1731C101.695 29.8879 103.051 30.9919 104.57 30.9919C105.731 30.9919 106.371 30.4148 106.773 29.7383H106.833V30.7274H108.501V25.8146C108.502 23.5411 106.967 22.2722 104.987 22.2722ZM104.778 29.2945C104.213 29.2945 103.423 28.9808 103.423 28.2059C103.423 27.2168 104.407 26.8375 105.256 26.8375C106.014 26.8375 106.372 27.019 106.833 27.266C106.699 28.454 105.776 29.2945 104.778 29.2945ZM114.577 22.552L112.596 28.1075H112.537L110.482 22.552H108.62L111.703 30.3164L109.945 34.6357H111.747L116.498 22.552H114.577ZM99.0158 30.75H100.743V17.9364H99.0158V30.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9055 10.499C43.9055 11.358 43.6759 12.0416 43.2157 12.5521C42.6934 13.1589 42.012 13.4623 41.1749 13.4623C40.3731 13.4623 39.6907 13.1548 39.1305 12.5398C38.5694 11.9238 38.2888 11.1612 38.2888 10.251C38.2888 9.33975 38.5694 8.57715 39.1305 7.96215C39.6907 7.34612 40.3731 7.03862 41.1749 7.03862C41.5731 7.03862 41.9536 7.12472 42.3147 7.2959C42.6768 7.4681 42.9666 7.69667 43.1833 7.98265L42.6953 8.52385C42.3277 8.03697 41.8212 7.79405 41.174 7.79405C40.5888 7.79405 40.0833 8.0216 39.6564 8.4767C39.2296 8.9318 39.0166 9.52322 39.0166 10.2499C39.0166 10.9767 39.2296 11.5681 39.6564 12.0232C40.0833 12.4783 40.5888 12.7058 41.174 12.7058C41.7944 12.7058 42.312 12.4773 42.7259 12.0191C42.9944 11.7208 43.1499 11.3057 43.1916 10.7737H41.174V10.0347H43.8657C43.8934 10.1956 43.9055 10.3504 43.9055 10.499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1741 7.93043H45.6445V9.87998H47.9259V10.619H45.6445V12.5686H48.1741V13.325H44.9306V7.17501H48.1741V7.93043Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1842 13.325H50.4703V7.93043H48.9184V7.17501H52.736V7.93043H51.1842V13.325Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.498 13.325V7.17501H56.2119V13.325H55.498Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3778 13.325H58.6639V7.93043H57.1121V7.17501H60.9297V7.93043H59.3778V13.325Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1563 12.5306C67.61 13.1518 66.9313 13.4623 66.1193 13.4623C65.3072 13.4623 64.6285 13.1518 64.0831 12.5306C63.5368 11.9095 63.2646 11.1489 63.2646 10.25C63.2646 9.35107 63.5368 8.59052 64.0831 7.96937C64.6285 7.34822 65.3072 7.03662 66.1193 7.03662C66.9267 7.03662 67.6044 7.34925 68.1526 7.97347C68.7007 8.5977 68.9748 9.3562 68.9748 10.25C68.9748 11.1489 68.7017 11.9095 68.1563 12.5306ZM64.61 12.015C65.0211 12.4763 65.5239 12.7059 66.1193 12.7059C66.7146 12.7059 67.2183 12.4753 67.6285 12.015C68.0396 11.5538 68.2461 10.9654 68.2461 10.25C68.2461 9.53455 68.0396 8.9462 67.6285 8.48495C67.2183 8.0237 66.7146 7.7941 66.1193 7.7941C65.5239 7.7941 65.0211 8.02472 64.61 8.48495C64.1998 8.9462 63.9933 9.53455 63.9933 10.25C63.9933 10.9654 64.1998 11.5538 64.61 12.015Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9767 13.325V7.17501H70.8452L73.5452 11.9587H73.5758L73.5452 10.7738V7.17501H74.2591V13.325H73.5137L70.6887 8.30866H70.6582L70.6887 9.49356V13.325H69.9767Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9055 10.499C43.9055 11.358 43.6759 12.0416 43.2157 12.5521C42.6934 13.1589 42.012 13.4623 41.1749 13.4623C40.3731 13.4623 39.6907 13.1548 39.1305 12.5398C38.5694 11.9238 38.2888 11.1612 38.2888 10.251C38.2888 9.33975 38.5694 8.57715 39.1305 7.96215C39.6907 7.34612 40.3731 7.03862 41.1749 7.03862C41.5731 7.03862 41.9536 7.12472 42.3147 7.2959C42.6768 7.4681 42.9666 7.69667 43.1833 7.98265L42.6953 8.52385C42.3277 8.03697 41.8212 7.79405 41.174 7.79405C40.5888 7.79405 40.0833 8.0216 39.6564 8.4767C39.2296 8.9318 39.0166 9.52322 39.0166 10.2499C39.0166 10.9767 39.2296 11.5681 39.6564 12.0232C40.0833 12.4783 40.5888 12.7058 41.174 12.7058C41.7944 12.7058 42.312 12.4773 42.7259 12.0191C42.9944 11.7208 43.1499 11.3057 43.1916 10.7737H41.174V10.0347H43.8657C43.8934 10.1956 43.9055 10.3504 43.9055 10.499Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1741 7.93043H45.6445V9.87998H47.9259V10.619H45.6445V12.5686H48.1741V13.325H44.9306V7.17501H48.1741V7.93043Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1842 13.325H50.4703V7.93043H48.9184V7.17501H52.736V7.93043H51.1842V13.325Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.498 13.325V7.17501H56.2119V13.325H55.498Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3778 13.325H58.6639V7.93043H57.1121V7.17501H60.9297V7.93043H59.3778V13.325Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1563 12.5306C67.61 13.1518 66.9313 13.4623 66.1193 13.4623C65.3072 13.4623 64.6285 13.1518 64.0831 12.5306C63.5368 11.9095 63.2646 11.1489 63.2646 10.25C63.2646 9.35107 63.5368 8.59052 64.0831 7.96937C64.6285 7.34822 65.3072 7.03662 66.1193 7.03662C66.9267 7.03662 67.6044 7.34925 68.1526 7.97347C68.7007 8.5977 68.9748 9.3562 68.9748 10.25C68.9748 11.1489 68.7017 11.9095 68.1563 12.5306ZM64.61 12.015C65.0211 12.4763 65.5239 12.7059 66.1193 12.7059C66.7146 12.7059 67.2183 12.4753 67.6285 12.015C68.0396 11.5538 68.2461 10.9654 68.2461 10.25C68.2461 9.53455 68.0396 8.9462 67.6285 8.48495C67.2183 8.0237 66.7146 7.7941 66.1193 7.7941C65.5239 7.7941 65.0211 8.02472 64.61 8.48495C64.1998 8.9462 63.9933 9.53455 63.9933 10.25C63.9933 10.9654 64.1998 11.5538 64.61 12.015Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9767 13.325V7.17501H70.8452L73.5452 11.9587H73.5758L73.5452 10.7738V7.17501H74.2591V13.325H73.5137L70.6887 8.30866H70.6582L70.6887 9.49356V13.325H69.9767Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_616_44826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66308 7.72619C9.39364 8.04189 9.23437 8.53184 9.23437 9.16632V31.8352C9.23437 32.4707 9.39364 32.9596 9.66308 33.2753L9.7316 33.3491L21.2029 20.6504V20.5008V20.3511L9.7316 7.65137L9.66308 7.72619Z",
    fill: "url(#paint0_linear_616_44826)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.026 24.885L21.2029 20.6507V20.5011V20.3514L25.027 16.1182L25.1131 16.1725L29.6436 19.022C30.9371 19.8358 30.9371 21.1673 29.6436 21.9822L25.1131 24.8317L25.026 24.885Z",
    fill: "url(#paint1_linear_616_44826)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_616_44826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1131 24.8306L21.202 20.501L9.66309 33.2755C10.089 33.7757 10.7936 33.8372 11.5872 33.3391L25.1131 24.8306Z",
    fill: "url(#paint2_linear_616_44826)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.1131 16.1713L11.5872 7.66381C10.7936 7.16464 10.089 7.22716 9.66309 7.72736L21.2029 20.5019L25.1131 16.1713Z",
    fill: "url(#paint3_linear_616_44826)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_616_44826",
    x: 9.23438,
    y: 7.31934,
    width: 21.3794,
    height: 26.3638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_616_44826"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_616_44826",
    result: "effect2_innerShadow_616_44826"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_616_44826",
    x: 9.66309,
    y: 20.501,
    width: 15.45,
    height: 13.1821,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_616_44826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_616_44826",
    x1: 20.186,
    y1: 8.92647,
    x2: 3.07299,
    y2: 24.3854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_616_44826",
    x1: 31.3274,
    y1: 20.5011,
    x2: 8.92381,
    y2: 20.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_616_44826",
    x1: 22.9891,
    y1: 22.8522,
    x2: -0.218338,
    y2: 43.8165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_616_44826",
    x1: 6.75697,
    y1: 0.181108,
    x2: 17.1197,
    y2: 9.54224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlaystore);
export default __webpack_public_path__ + "static/media/GooglePlaystore.b0e84431aba96eff298cfb0af0cab822.svg";
export { ForwardRef as ReactComponent };